class MenuAdvertising extends HTMLElement {
    constructor() {
        super();
        this.items = this.querySelectorAll('.submenu-down-list__advertising_item');
    }

    connectedCallback() {
        this.items.forEach(item => {
            item.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
        });
    }

    disconnectedCallback() {
        this.items.forEach(item => {
            item.removeEventListener('mouseenter', this.handleMouseEnter.bind(this));
        });
    }

    handleMouseEnter(event) {
        this.items.forEach(item => {
            item.setAttribute('aria-expanded', 'false');
        });

        event.target.setAttribute('aria-expanded', 'true');
    }
}

customElements.define('menu-advertising', MenuAdvertising);
